import * as React from "react";
import BaseModal from "./BaseModal";

const MessageModal=(props)=>{

    return(
        <>
            <BaseModal
                open={false}
            >
              <h1>Message</h1>
            </BaseModal>
        </>
    )
}

export default MessageModal;


